// Data Uploads: honest coming-soon page. No fake stored files, no dead
// controls, no claims about processing we do not do yet. Frame matches the
// locked-feature pattern (icon tile + "Coming soon" pill + highlights).
import { AIAssistantSidebar } from "./ai-assistant-sidebar";
import { Database, Check, Sparkles } from "lucide-react";

interface DataUploadsPageProps {
  isSidebarCollapsed: boolean;
  onSidebarToggle: (collapsed: boolean) => void;
}

const PLANNED_HIGHLIGHTS = [
  "Upload CSV, Excel, and JSON files",
  "Bring historical metrics and competitor data into your analyses",
  "Manage and remove your uploaded files at any time",
];

export function DataUploadsPage({ isSidebarCollapsed, onSidebarToggle }: DataUploadsPageProps) {
  return (
    <div className="flex min-h-screen">
      {/* Main Content */}
      <div className={`flex-1 transition-all duration-300 ${isSidebarCollapsed ? "mr-12" : "mr-[380px]"}`}>
        <div className="max-w-[1400px] mx-auto p-8">
          <div className="bg-card border border-border rounded-xl p-8 shadow-[var(--elevation-sm)]">
            <div className="flex items-start gap-6">
              <div className="flex-shrink-0 w-16 h-16 rounded-xl bg-[var(--signal-blue-10)] flex items-center justify-center">
                <Database className="w-8 h-8 text-[var(--signal-blue)]" />
              </div>
              <div className="flex-1">
                <div className="flex items-center gap-3 mb-3 flex-wrap">
                  <h1>Data Uploads</h1>
                  <span
                    className="inline-flex items-center"
                    style={{
                      gap: 6, fontSize: 11, fontWeight: 600,
                      color: "var(--signal-blue)", background: "var(--signal-blue-10)",
                      padding: "4px 9px", borderRadius: 6,
                    }}
                  >
                    <Sparkles style={{ width: 13, height: 13, strokeWidth: 1.75 }} /> Coming soon
                  </span>
                </div>
                <p className="text-muted-foreground mb-6">
                  Uploading your own datasets isn't available yet. When it launches, you'll be able to
                  bring spreadsheets and data files into Upmode to enrich AI analysis.
                </p>
                <div style={{ display: "flex", flexDirection: "column", gap: 8 }}>
                  {PLANNED_HIGHLIGHTS.map((h) => (
                    <div key={h} className="flex items-center text-foreground" style={{ gap: 9, fontSize: 13 }}>
                      <span
                        className="inline-flex items-center justify-center shrink-0"
                        style={{ width: 18, height: 18, borderRadius: 6, background: "var(--alpha-teal-10)", color: "var(--ai-teal-text, #04938F)" }}
                      >
                        <Check style={{ width: 12, height: 12, strokeWidth: 2.2 }} />
                      </span>
                      {h}
                    </div>
                  ))}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* AI Assistant Sidebar */}
      <AIAssistantSidebar isCollapsed={isSidebarCollapsed} onToggleCollapse={onSidebarToggle} />
    </div>
  );
}
